import { render, staticRenderFns } from "./PedidosCompraPagamentos.vue?vue&type=template&id=b0ecb472&scoped=true&"
import script from "./PedidosCompraPagamentos.vue?vue&type=script&setup=true&lang=js&"
export * from "./PedidosCompraPagamentos.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ecb472",
  null
  
)

export default component.exports